"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
export const SYNC_AUTH_LOCAL_STORAGE_KEY = "opensea-wallet-sync-auth";

/**
 * Use local storage message to sync auth status across tabs
 */
export const useSyncAuth = () => {
  const $ = _c(1);
  const syncAuth = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      syncAuth
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp() {
  const currentKey = localStorage.getItem(SYNC_AUTH_LOCAL_STORAGE_KEY) ?? "0";
  localStorage.setItem(SYNC_AUTH_LOCAL_STORAGE_KEY, currentKey === "0" ? "1" : "0");
  window.dispatchEvent(new StorageEvent("storage", {
    key: SYNC_AUTH_LOCAL_STORAGE_KEY
  }));
}